module.exports = __webpack_public_path__ + "img/alunos.d4e0c20d.svg";